import React, { useState, useRef, useEffect } from "react";
import { Globals as OldGlobals } from "../../global/Globals";
import { formatDate } from '../../util/util';
import Loader from "../../components/Loader/Loader";
import NoResultsComponent from "../../components/NoResults/NoResult";
import './CEEvalViewAccordion.css';
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import Button from "../../components/Button/Button";
import { updateCEEvalList } from "../../services/GenericAPI";
import Toast from "../../components/Toast/Toast";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../context/Languagecontext";
const CEEvalViewAccordion = ({ data, getCEEvalDetails, proposalStatus, clusterCEList, existingCEList, _proposalDeatilId, _proposalId, close, tabName, evalStatus, roleID, ceEvalAPIFailure }) => {
    const { Globals } = useLanguage();
    const navigate = useNavigate();
    const dropdownRefs = useRef({});
    const latestComment = '';
    const [contentDataStatus, setContentDataStatus] = useState(null)
    const [isEvaluationExpanded, setEvaluationExpand] = useState(false);
    const [expandedCardIndex, setExpandedCardIndex] = useState({});
    const [criterias, setCriterias] = useState();
    const [smEvaluationData, setSmEvaluationData] = useState(null);
    const [scoreStatus, setScoreStatus] = useState("ceEval-final-score-result-layout-label-status")
     const [isDropDownOpen, setIsDropDownOpen] = useState(false);
     const [recentCEDetails, setRecentCEDetails]=useState(null);
    const ceOptions = clusterCEList?.map((item,index)=>({
        "id":item.userId,
        "name":item.fullName
    }));
    const [dropdownState, setDropdownState] = useState({
        activeDropdown: false,
        dropdowns: { selected: [], selectedText: [] },
    });
    const [isEditClicked, setIsEditClicked]=useState(false);
    const toggleCardExpansion = (index) => {
        setExpandedCardIndex((prevOpenItems) => ({
            ...prevOpenItems,
            [index]: !prevOpenItems[index],
        }))
    };

    /** Edit CE List Implementation --- Start */
    
    const handleSelect = (value) => {
        setRecentCEDetails(value);
        setDropdownState((prev) => {
            const dropdown = prev.dropdowns;
            if (!dropdown) return prev;
            const isSelected = dropdown.selected.includes(String(value.id));
            const inSelectedText = dropdown.selectedText.includes(String(value.name));
            const newSelected = isSelected
                ? dropdown.selected.filter((item) => item !== String(value.id)).map(String)
                : [...dropdown.selected.filter((item) => item !== String(value.id)), String(value.id)];

            const newSelectedText = inSelectedText
                ? dropdown.selectedText.filter((item) => item !== String(value.name)).map(String)
                : [
                    ...dropdown.selectedText.filter((item) => item !== String(value.name)),
                    String(value.name),
                ];
            return {
                ...prev,
                dropdowns: {
                    selected: newSelected,
                    selectedText: newSelectedText,
                },
            };
        });
    }
    const handleSelectAll = (selectAll, options) => {
        const selectedDataSting = options.map((option) => String(option.id));
        const selectedDataText = options.map((option) => String(option.name));
        setDropdownState((prev) => ({
            ...prev,
            dropdowns: {
                selected: selectAll ? selectedDataSting : [],
                selectedText: selectAll ? selectedDataText : [],
            },
        }));
    };

    const handletog = (value) => {
        value && !dropdownState.dropdowns.selected.length > 0
            ? setIsDropDownOpen(true)
            : setIsDropDownOpen(false);
        setDropdownState((prev) => ({ ...prev, activeDropdown: !value }));
    };

    const handleCEDropDownlist=()=>{
        setIsEditClicked(true);
    }

    useEffect(() => {
        if (dropdownState.activeDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [dropdownState]);

    const handleClickOutside = (event) => {
        // Check if the click is outside all dropdowns
        const isClickInsideDropdown = Object.values(dropdownRefs.current).some(
            (ref) => ref?.contains(event.target)
        );
        if (!isClickInsideDropdown) {
            handletog(dropdownState.activeDropdown);
        }
    };

    const updateCEList = async () => {
        let requestBody;
        if (dropdownState.dropdowns.selected.length === 0) {
            requestBody = [{
                "proposalDetailId": _proposalDeatilId,
                "proposalId": _proposalId.toString()
            }]

        }
        else {
            requestBody = dropdownState.dropdowns.selected.map((item, index) => ({
                "proposalDetailId": _proposalDeatilId,
                "proposalId": _proposalId.toString(),
                "userId": item.toString()
            }))
        }
        try {
            const response = await updateCEEvalList(requestBody);
            if (response?.data?.content === true && response?.data?.status === "OK") {
                renderToast("success",Globals.UPDATE_CE_LIST_SUCCESS);
            }
            else {
                console.error("Error updating CE list:", response?.data?.status);
                renderToast("error",Globals.UPDATE_CE_LIST_FAILURE);
            }
        }
        catch (error) {
            console.error("Error updating CE list:", error);
            renderToast("error",Globals.UPDATE_CE_LIST_FAILURE);
        }
    }
    
    const renderToast = (status, toastValue) => {
        close();
        if (status === "success") {
            navigate(Globals.NAVPATH.HOME, { state: { activeHeader: "all_proposals", selectedTab: tabName, toastValue: toastValue } })
        }
        else {
            navigate(Globals.NAVPATH.HOME, { state: { activeHeader: "all_proposals", selectedTab: tabName, errorToastValue: toastValue } })
        }
    }

    useEffect(() => {
        const newList= clusterCEList
            ?.filter(item => existingCEList.includes(item.fullName))
            .map(item => ({
                id: item.userId,
                name: item.fullName
            }));
        if (dropdownState.dropdowns.selected.length === 0) {
            setDropdownState((prev) => {
                return {
                    ...prev,
                    dropdowns: {
                        selected: newList ? newList.map(item => String(item.id)) : [],
                        selectedText: newList ? newList.map(item => String(item.name)) : []
                    }
                }
            })
        }

    }, [])
    /** Edit CE List Implementation --- End */
    return (
        <>
            <div className="ceEval-halfscreen-accordion">
                <div className={`Half ${isEvaluationExpanded ? 'active' : ''}`}>
                    <div
                        className="ceEval-halfscreen-accordion-expandable-header"
                        onClick={() => { setEvaluationExpand(!isEvaluationExpanded) }}
                    >
                        <label className="ceEval-half-screen-accordion-title">{Globals.CE_EVALUATION_ACCORDION_TITLE}</label>
                        <img
                            className='ceEval-accordion-arrow'
                            onClick={() => { setEvaluationExpand(!isEvaluationExpanded) }}
                            src={isEvaluationExpanded ? Globals.IMG.ARROW_UP : Globals.IMG.ARROW_DOWN}
                            alt="toggle icon"
                        />
                    </div>
                    {isEvaluationExpanded && <>
                    <br/>
                        <div className="ce-list-group">
                            {tabName==="unSolicited" &&<div className="ce-list-preloaded">
                                <label className="ce-list-halfscreen-ce-eval-accordion">{Globals.SUMMARY_CARD_NAME.commisionerEditors}</label>
                                <span className="ce-preloaded-values">{existingCEList?existingCEList.join(', '):'N/A'}</span>
                                {(roleID.toString()===Globals.USER_ROLES.CC && existingCEList && evalStatus===1)&&<span>{(!isEditClicked&&proposalStatus===1&&clusterCEList?.length>0)?<img src={Globals.IMG.PROPOSALEDIT_ENABLED} alt='edit' onClick={handleCEDropDownlist} className="ce-list-edit-Btn"/>:<img src={Globals.IMG.PROPOSALEDIT_DISABLED} alt="edit" className="ce-list-edit-Btn"/>}</span>}
                            </div>}
                            {(tabName==="unSolicited" && isEditClicked && clusterCEList?.length>0)&&<div className="ce-dropdown-halfscreen-ce-eval-accordion">
                                <div className="ce-dropdown">
                                <CheckboxDropDown
                                    isCreatedBy={true}
                                    isOpen={dropdownState.activeDropdown}
                                    options={ceOptions}
                                    onToggle={() => handletog(dropdownState.activeDropdown)}
                                    onSelectAll={(selectAll, options) => handleSelectAll(selectAll, options)}
                                    onSelect={handleSelect}
                                    selectedValues={dropdownState.dropdowns.selected}
                                    title={Globals.SUMMARY_CARD_NAME.commisionerEditors}
                                    selectedItems={dropdownState.dropdowns.selectedText}
                                    className={"ce-dropdown-content"}
                                    outerDivClassName={"rejectionDropdownSize"}
                                    longInputText={true}
                                    dropdownRef={(el) => (dropdownRefs.current["VirtualPitch"] = el)} />
                                </div>
                                <Button title={'Save'} additionalStyle={'save-ce-btn'} action={updateCEList}/>
                            </div>}
                        </div>
                        {evalStatus!==1 && proposalStatus>=1 && data?.evaluationDetails?.length > 0 ? (
                            <>
                                <div className='ceEval-final-score-reslult-layout'>
                                    <label className='ceEval-final-score-reslult-layout-label'>{Globals.SENIOR_MANAGER.FINAL_SCORE}{data?.evaluationDetails?.[0]?.finalScore}
                                    </label>
                                    <label className='ceEval-final-score-reslult-layout-label'>{Globals.SENIOR_MANAGER.SCORING_STATUS}<label className={data?.evaluationDetails?.[0]?.status === Globals.FAILED ? 'ceEval-final-score-result-layout-label-status-failed' : scoreStatus}>{data?.evaluationDetails?.[0]?.status}</label></label>
                                </div>
                                <div className='ceEval-final-score-reslult-layouts'>
                                    {/* <div className='ceEval-criteria-layout'>
                                    {criterias?.length > 0 && criterias?.map((gradeItem, index) => {
                                        return (
                                            <label key={index} className='ceEval-criteria-layout-text'>{gradeItem} {(criterias.length - 1) > (index) ? <p className='sm-criteria-lable-pipe'>|</p> : ""} </label>
                                        )
                                    })}
                                </div> */}
                                    <div className="ceEvaluation-list-layout">
                                        {data?.evaluationDetails?.map((item, index) => (
                                            <div className='ceEval-card-layout' key={index}>
                                                <div>
                                                    <label className='ce-layout-label'>{item.ceName}</label><label className='ce-layout-label'> | </label><label className='ce-layout-label'>{Globals.SENIOR_MANAGER.EVALUATED_ON}{formatDate(item.evaluatedOn)}</label>
                                                    <div className='ceEval-final-score-reslult-layout'>
                                                        <div className="ce-scrore">
                                                            <label className='ceEval-final-score-reslult-layout-label'>{Globals.SENIOR_MANAGER.SCORE}</label>&nbsp;<label className='ceEval-final-score-result-layout-label-status-default'>{data?.evaluationDetails?.[index]?.totalScore}</label>
                                                        </div>
                                                    </div>
                                                    {/* Rattings layout: */}

                                                    <div className='ceEval-rating-root-layout' key={index}>
                                                        {item.gradeEvaluations.map((gradeItem, gradeIndex) => {
                                                            return (
                                                                <div className='ceEval-ratings-layout'>
                                                                    <label className='ceEval-ratings-text' key={gradeIndex}>{gradeItem.criteriaName} : {gradeItem.gradeValue}</label>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>

                                                    <div>
                                                        <label className="ceEval-score-description-text">{item.comments}</label>

                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                </div>
                            </>
                        ) : (evalStatus!==1 && proposalStatus>=1 && ceEvalAPIFailure ? (<div><label id="no-ce-list" className="no-ce-list">{Globals.NO_CE_FOUND}</label></div>) : '')
                        // (!data?.evaluationDetails) ? (
                        //     <NoResultsComponent
                        //         data={{
                        //             message: Globals.HALF_PAGE_MESSAGE,
                        //             img: Globals.IMG.HALF_PAGE_ERROR,
                        //             submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                        //             className: 'ErrorHeader',
                        //             subclassName: 'SubError',
                        //             outerWrapper: 'HalfPageWrapper',
                        //             button: 'reload',
                        //         }}
                        //         handleReload={getCEEvalDetails}
                        //     />
                        // ) : (
                        //     <div className="NoResultsComponent" style={{ height: '80vh' }}>
                        //         <Loader height={50} width={50} />
                        //     </div>
                        // )
                        }</>
                    }
                </div>
            </div>
        </>
    )
}

export default CEEvalViewAccordion;